import { Box, VStack, HStack, Center, Divider } from "@chakra-ui/react";
import { Display03, Label01, Paragraph04 } from "~/components/Texts";
import Link from "next/link";

export default function OrderDetailsHeader({ shop, order }) {
  return (
    <VStack w="100%" align="flex-start">
      <HStack w="100%">
        <VStack align="flex-start">
          <Display03>Orden de compra</Display03>
          <Label01>{shop.displayNames.es}</Label01>
        </VStack>
        <Box flex="1 " />
        <VStack>
          <Box boxSize="72px" position="relative">
            <Link href={`/${shop.domains[0]}`}>
              <a>
                <Center width="72px" height="72px">
                  {shop.logo && (
                    <img
                      src={shop.logo?.src}
                      objectFit="contain"
                      draggable="false"
                    />
                  )}
                </Center>
              </a>
            </Link>
          </Box>
          <Paragraph04>{order.createdAt.toDate().toLocaleString()}</Paragraph04>
        </VStack>
      </HStack>
      <Divider
        w="100%"
        h="2px"
        backgroundColor={shop.theme.colors.background.strong}
      />
    </VStack>
  );
}
